var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81409 5.10404C4.94143 5.10404 5.0382 5.06317 5.10951 4.98653L7.20798 2.87134C7.29966 2.78449 7.33531 2.6823 7.33531 2.56479C7.33531 2.45239 7.28947 2.33999 7.20798 2.25824L5.10951 0.12262C5.0382 0.0408732 4.93633 0 4.81409 0C4.58489 0 4.41171 0.183929 4.41171 0.41895C4.41171 0.526242 4.45246 0.628425 4.52377 0.710172L5.8837 2.04877C5.59338 1.99768 5.29796 1.96702 5.00255 1.96702C2.50679 1.96702 0.5 3.97492 0.5 6.4784C0.5 8.98699 2.50679 11 5.00255 11C7.4983 11 9.5 8.98699 9.5 6.4784C9.5 6.23316 9.32683 6.05434 9.07725 6.05434C8.83786 6.05434 8.67997 6.23316 8.67997 6.4784C8.67997 8.53228 7.04499 10.1774 5.00255 10.1774C2.9601 10.1774 1.32003 8.53228 1.32003 6.4784C1.32003 4.42963 2.9601 2.7896 5.00255 2.7896C5.38964 2.7896 5.74618 2.82025 6.05178 2.88667L4.52886 4.40409C4.45246 4.48583 4.41171 4.58802 4.41171 4.69531C4.41171 4.93033 4.58489 5.10404 4.81409 5.10404Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowCircle);
export default __webpack_public_path__ + "static/media/icon-arrow-circle.24e374c1c2bdbde2fe30b7653872324a.svg";
export { ForwardRef as ReactComponent };